import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useMemo, useState, React, useEffect, useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { MainContext } from "context/MainContext.js";

import ReactBSAlert from "react-bootstrap-sweetalert";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import Utilities from "components/Utils/utilities";
import { useTranslation } from "react-i18next";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FaCheckCircle,
  FaSearch,
  FaSpinner,
  FaQuestion,
  FaFolderOpen,
  FaScrewdriver,
  FaTasks,
  FaShieldAlt,
  FaVideo,
} from "react-icons/fa";
import { BsFillXCircleFill } from "react-icons/bs";
import Select from "react-select";
import Moment from "moment";
import "moment-timezone";
import { ToastContainer, toast } from "react-toastify";

import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;

const SiteDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [forceRefreshCount, setForceRefreshCount] = useState(0);
  const privileges = useContext(MainContext);

  const [alert, setAlert] = useState(null);
  const [site, setSite] = useState();
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["installations.site.list"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData();
  }, []);

  const [status, setStatus] = useState(
    location.state && location.state.status ? location.state.status : "all",
  );

  const [siteId, setSiteId] = useState(
    location.state ? location.state.siteId : "",
  );

  const fetchData = () => {
    fetch("/api/v1/site/details", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        param: siteId,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setSite(actualData.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const resetConfiguration = (macAddress) => {
    setShowLoading(true);
    fetch("/api/v1/site/reset_configuration", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: macAddress,
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error(actualData.error_code[0], {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          toast.success("Endpoint reset successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const launchConfiguration = (roomId) => {
    setShowLoading(true);
    fetch("/api/v1/site/launch_configuration", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: roomId,
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error(actualData.error_code[0], {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          toast.success("Endpoint configured successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const redirectToRoomEdit = (roomId) => {
    const location = {
      pathname: "/admin/installations/site/endpoint/edit",
      state: {
        roomId: roomId ? roomId : "",
        siteId: siteId,
        mode: "edit",
      },
    };
    history.push(location);
  };

  const redirectToRoomDetails = (roomId) => {
    const location = {
      pathname: "/admin/installations/site/endpoint/details",
      state: {
        roomId: roomId ? roomId : "",
        siteId: siteId,
      },
    };
    history.push(location);
  };

  const redirectToProfileEdit = (profileId) => {
    const location = {
      pathname: "/admin/installations/profile/edit",
      state: {
        id: profileId ? profileId : "",
        site: site ? site.name : "",
        mode: "edit",
      },
    };
    history.push(location);
  };

  const redirectToEndpointDetails = (endpointId) => {
    const location = {
      pathname: "/admin/endpoints/details",
      state: {
        endpointId: endpointId,
      },
    };
    history.push(location);
  };

  const redirectToDeviceDetails = (serialNumber) => {
    const location = {
      pathname: "/admin/devices/details",
      state: {
        value: serialNumber,
      },
    };
    history.push(location);
  };

  const showDetailsButton = (detailsValue) => {
    if (detailsValue) {
      return (
        <DropdownItem
          onClick={() =>
            setAlert(
              <ReactBSAlert
                style={{
                  display: "block",
                  marginTop: "-100px",
                  width: "600px",
                  maxWidth: "60%",
                }}
                onConfirm={() => hideAlert()}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="info"
                btnSize=""
              >
                {detailsValue.split("||").map((line) => (
                  <>
                    {line}
                    <br />
                  </>
                ))}
              </ReactBSAlert>,
            )
          }
        >
          Show Details
        </DropdownItem>
      );
    } else {
      return <></>;
    }
  };

  const filterButtonsOptions = [
    { value: "all", label: "All", key: "all" },
    { value: "configured", label: "Configured", key: "configured" },
    { value: "attention", label: "Requiring Attention", key: "attention" },
    { value: "waiting", label: "Waiting", key: "waiting" },
    { value: "notyetseen", label: "Not Yet Seen", key: "notyetseen" },
  ];

  const filterButtons = useMemo(() => {
    let defaultValue = filterButtonsOptions.find((c) => c.value == status);
    if (defaultValue == undefined) {
      defaultValue = filterButtonsOptions[0];
    }

    return (
      <Select
        className="react-select primary"
        classNamePrefix="react-select"
        name="filterButton"
        defaultValue={defaultValue}
        onChange={(option) => {
          setStatus(option.value.value);
          setForceRefreshCount((prevValue) => prevValue + 1);
        }}
        isHidden="true"
        options={filterButtonsOptions.map((option) => ({
          value: {
            ...option,
            toString: () => `${option.value}`,
          },
          label: `${option.label}`,
        }))}
      />
    );
  });

  const hideAlert = () => {
    setAlert(null);
  };

  const columns = [
    {
      Header: "Status",
      accessor: "status",
      flex: "0 1 5%",
      sortable: false,
      filterable: false,
      Cell: ({ row, value }) => {
        let icon = (
          <FaSearch
            className="tableIconFontSize"
            style={{ color: "darkgrey" }}
          />
        );
        if (value === "CONFIGURED_DIVERGE") {
          icon = <FaCheckCircle className="text-warning tableIconFontSize" />;
        } else if (value === "CONFIGURED") {
          icon = <FaCheckCircle className="text-info tableIconFontSize" />;
        } else if (value === "ERROR") {
          icon = (
            <BsFillXCircleFill className="text-danger tableIconFontSize" />
          );
        } else if (value === "WAITING") {
          icon = <FaSpinner className="text-primary tableIconFontSize" />;
        } else if (value === "CONFIGURED_OFFLINE") {
          icon = <FaQuestion className="text-danger tableIconFontSize" />;
        } else if (value === "VERIFIED") {
          icon = <FaShieldAlt className="tableIconFontSize" />;
        } else if (value === "VERIFIED_ISSUE") {
          icon = <FaShieldAlt className="text-warning tableIconFontSize" />;
        }

        const tooltipId = `vmElement-${row.index}`;

        return (
          <>
            <a id={tooltipId} className="vmElement">
              {icon}
            </a>
            <ReactTooltip
              anchorSelect={`#${tooltipId}`}
              place="top"
              style={{ textAlign: "left", zIndex: "100" }}
            >
              <div>{t("table.row.status." + value)}</div>
              {row.original.errorMsg ? (
                <div style={{ marginTop: "10px" }}>
                  {row.original.errorMsg.split(" | ").map((msg, index) => (
                    <div key={index}>{msg}</div>
                  ))}
                </div>
              ) : (
                ""
              )}
            </ReactTooltip>
          </>
        );
      },
    },
    {
      Header: "Endpoint",
      accessor: "number",
      sortBy: "r.number",
      flex: "1 1 0",
      Cell: (props) => {
        const roomId = props.row.original.roomId;

        return roomId ? (
          <a
            onClick={() => redirectToRoomDetails(roomId)}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        ) : (
          <span>{props.value}</span>
        );
      },
    },
    {
      Header: "MacAddress",
      accessor: "macAddress",
      sortBy: "r.macAddress",
      flex: "1 1 0",
      Cell: (props) => {
        const endpointId = props.row.original.endpointId;
        const provisioningDate = props.row.original.provisioningDate;

        return provisioningDate ? (
          <a
            onClick={() => redirectToEndpointDetails(endpointId)}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        ) : (
          <span>{props.value}</span>
        );
      },
    },
    {
      Header: "Profile",
      accessor: "profileName",
      sortBy: "r.profile.name",
      flex: "1 1 0",
      Cell: (props) => {
        if (props.row.original.siteLock) {
          return props.value;
        } else {
          return (
            <a
              onClick={() =>
                redirectToProfileEdit(props.row.original.profileId)
              }
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {props.value}
            </a>
          );
        }
      },
    },
    {
      Header: "Provisioning Date",
      accessor: "provisioningDate",
      sortBy: "r.provisioningDate",
      Cell: (props) => {
        return props.value ? (
          <div style={{ width: "100%" }}>
            {props.settings.general_convert_date_with_user_timezone === "true"
              ? Moment(props.value)
                  .tz(props.settings.user_timezone)
                  .format("yy-MM-DD hh:mm a")
              : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
          </div>
        ) : (
          ""
        );
      },
      flex: "1 1 0",
    },
    {
      Header: "System Name",
      accessor: "systemName",
      sortBy: "d.name",
      flex: "1 1 0",
      Cell: (props) => {
        return (
          <a
            onClick={() =>
              redirectToDeviceDetails(props.row.original.serialNumber)
            }
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        );
      },
    },
    {
      Header: "Serial Number",
      accessor: "serialNumber",
      sortBy: "d.serialNumber",
      flex: "1 1 0",
    },
    {
      Header: "IP Address",
      accessor: "ipAddress",
      sortBy: "d.ipAddress",
      flex: "1 1 0",
    },
    {
      Header: "",
      accessor: "actions",
      Cell: (props) => {
        if (!props.row.original.siteLock) {
          return (
            <UncontrolledDropdown direction="down">
              <DropdownToggle
                caret
                color="info"
                style={{
                  padding: "6px 14px 6px 14px",
                }}
              >
                Actions
              </DropdownToggle>
              <DropdownMenu container={"body"}>
                <DropdownItem
                  onClick={() => redirectToRoomEdit(props.row.original.roomId)}
                >
                  Edit Endpoint
                </DropdownItem>

                {props.row.original.status == "CONFIGURED_DIVERGE" ? (
                  <>
                    {showDetailsButton(props.row.original.details)}
                    <DropdownItem
                      onClick={() =>
                        resetConfiguration(props.row.original.roomId)
                      }
                    >
                      Reapply
                    </DropdownItem>
                  </>
                ) : (
                  ""
                )}

                {props.row.original.status == "ERROR" ? (
                  <DropdownItem
                    onClick={() =>
                      launchConfiguration(props.row.original.roomId)
                    }
                  >
                    Retry
                  </DropdownItem>
                ) : (
                  ""
                )}

                {props.row.original.status == "WAITING" ? (
                  <DropdownItem
                    onClick={() =>
                      launchConfiguration(props.row.original.roomId)
                    }
                  >
                    Execute
                  </DropdownItem>
                ) : (
                  ""
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        } else {
          return "";
        }
      },
      flex: "1 1 0",
      padding: "0px",
      sortable: false,
      filterable: false,
    },
  ];

  const showStatus = () => {
    if (!site) {
      return "";
    }

    const tooltipId = `vmElement-${site.status}`;

    var icon = null;
    var value = null;

    if (site.status == "NEW") {
      icon = <FaFolderOpen className="tableIconFontSize" />;
      value = "New";
    } else if (site.status == "IN_PROGRESS") {
      icon = <FaScrewdriver className="tableIconFontSize" />;
      value = "Provisioning in progress";
    } else if (site.status == "VERIFICATION") {
      icon = <FaTasks className="tableIconFontSize" />;
      value = "Verification in progress";
    } else if (site.status == "VERIFIED") {
      icon = <FaShieldAlt className="tableIconFontSize" />;
      value = "Verified";
    } else if (site.status == "MONITORING") {
      icon = <FaVideo className="tableIconFontSize" />;
      value = "Monitoring";
    }
    return (
      <>
        <a id={tooltipId} className="vmElement">
          {icon}
        </a>
        <ReactTooltip
          anchorSelect={`#${tooltipId}`}
          place="top"
          style={{ textAlign: "left", zIndex: "100" }}
        >
          <div>{value}</div>
        </ReactTooltip>
      </>
    );
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/installations/site/list",
                      }}
                    >
                      {t(
                        "sites.breadcrumb.sites.t." +
                          sessionStorage.getItem("bundleType"),
                        "Sites",
                      )}
                    </NavLink>
                    {siteId ? <i>&lt;{site ? site.name : ""}&gt;</i> : ""}
                  </BreadcrumbItem>
                  <BreadcrumbItem>Details</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col>
                      <FormGroup>
                        <label>Status</label>
                        <p> {showStatus()}</p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Name</label>
                        <p> {site ? site.name : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Address</label>
                        <p> {site ? site.address : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    {" "}
                    <ReactTable
                      query="/api/v1/site/room/list"
                      columns={columns}
                      param={siteId + "||" + status}
                      title="Rooms"
                      filterButtons={filterButtons}
                      forceRefresh={forceRefreshCount}
                      className="-striped -highlight primary-pagination"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SiteDetails;
